import { SVGProps } from 'react';

export const Home = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M1.5 7.99989L7.46967 2.03022C7.76256 1.73732 8.23744 1.73732 8.53033 2.03022L14.5 7.99989M3 6.49989V13.2499C3 13.6641 3.33579 13.9999 3.75 13.9999H6.5V10.7499C6.5 10.3357 6.83579 9.99989 7.25 9.99989H8.75C9.16421 9.99989 9.5 10.3357 9.5 10.7499V13.9999H12.25C12.6642 13.9999 13 13.6641 13 13.2499V6.49989M5.5 13.9999H11'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
